import { useTranslations } from '@vocab/react';
import { Actions, Button, Text, TextField, Stack } from 'braid-design-system';

import type { ServerError as ServerErrorType } from 'src/types';

import ServerError from '../../ServerError/ServerError';

import translations from './.vocab';

interface Props {
  openDialog: () => void;
  error?: ServerErrorType | null;
  toggle: () => void;
  submitting: boolean;
  email: string;
}

const Form = ({ openDialog, error, toggle, submitting, email }: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="xlarge">
      <Stack space="medium">
        <Stack space="small">
          <Text>
            {t(
              'Your account registered with the following email will be deleted.',
            )}
          </Text>
          <TextField
            disabled
            id="email"
            name="email"
            type="email"
            aria-label={t('Email')}
            value={email}
            onChange={() => {}}
          />
        </Stack>
      </Stack>

      {error && !submitting ? <ServerError error={error} /> : null}
      <Actions>
        <Button onClick={openDialog} tone="critical" id="openDeleteDialog">
          {t('Delete account')}
        </Button>
        <Button variant="transparent" tone="formAccent" onClick={toggle}>
          {t('Cancel')}
        </Button>
      </Actions>
    </Stack>
  );
};

export default Form;
